export const spacings = {
  contentPadding: '100px',
  contentPaddingLeft: '100px',
  contentMarginBottom: '20px',
};
